/**
 *
 * HeroMessageBold
 *
 */

import React from 'react';
import PropTypes from 'prop-types';
// import styled from 'styled-components';

function HeroMessageBold(props) {
  return <span className="hero__bold">{props.children}</span>;
}

HeroMessageBold.propTypes = {
  children: PropTypes.node.isRequired,
};

export default HeroMessageBold;
